import {
  AUTH_CHECK_TOKEN,
  AUTH_FETCH_SUCCESS,
  AUTH_SIGNIN,
  AUTH_SIGNIN_SUCCESS,
  AUTH_SIGNOUT,
  AUTH_SIGNOUT_SUCCESS,
  AUTH_CLOSE_POPUP,
  AUTH_OPEN_POPUP,
  AUTH_PROFILE_FETCH,
  AUTH_PROFILE_FETCH_SUCCESS,
  MEMBER_PROFILE_FETCH,
  MEMBER_PROFILE_FETCH_SUCCESS,
  MEMBER_PROFILE_UPDATE,
  MEMBER_PROFILE_CHANGE_PASSWORD,
  PDPA_REQUEST,
  PDPA_REQUEST_SUCCESS,
} from "./types";

export const validateToken = (payload) => {
  return {
    type: AUTH_CHECK_TOKEN,
    payload,
  };
};

export const authFetchResponse = (payload) => {
  return {
    type: AUTH_FETCH_SUCCESS,
    payload,
  };
};

export const authSignIn = (payload) => {
  return {
    type: AUTH_SIGNIN,
    payload,
  };
};

export const authSignInSuccess = (payload) => {
  return {
    type: AUTH_SIGNIN_SUCCESS,
    payload,
  };
};

export const authSignOut = () => {
  return {
    type: AUTH_SIGNOUT,
  };
};

export const authSignOutSuccess = () => {
  return {
    type: AUTH_SIGNOUT_SUCCESS,
  };
};

export const authClosePopup = () => {
  return {
    type: AUTH_CLOSE_POPUP,
  };
};

export const authOpenPopup = () => {
  return {
    type: AUTH_OPEN_POPUP,
  };
};

export const authProfileFetch = (payload) => {
  return {
    type: AUTH_PROFILE_FETCH,
    payload,
  };
};

export const authProfileFetchSuccess = (payload) => {
  return {
    type: AUTH_PROFILE_FETCH_SUCCESS,
    payload,
  };
};

export const memberProfileFetch = () => {
	return {
		type: MEMBER_PROFILE_FETCH
	}
}

export const memberProfileFetchSuccess = member => {
	return {
		type: MEMBER_PROFILE_FETCH_SUCCESS,
		payload: member
	}
}


export const memberProfileUpdate = member => {
	return {
		type: MEMBER_PROFILE_UPDATE,
		payload: member
	}
}

export const memberChangePassword = (password, closeModal) => {
	return {
		type: MEMBER_PROFILE_CHANGE_PASSWORD,
		payload: password , closeModal
	}
}

export const sendAgrementPDPA = payload => {
	return {
		type: PDPA_REQUEST,
		payload: payload
	}
}

export const sendAgrementPDPASuccess = payload => {
	return {
		type: PDPA_REQUEST_SUCCESS,
		payload: payload
	}
}


